import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';

import './index.css';
import './lib/crisp';
import { ClerkProviderWrapper } from './lib/clerk';
import { PostHogProvider } from './lib/posthog';
import { queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';

// Create a simple router instance
const router = createRouter({
  routeTree,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider>
      <QueryClientProvider client={queryClient}>
        <ClerkProviderWrapper>
          <RouterProvider router={router} />
        </ClerkProviderWrapper>
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>
);
